"use client"

import { DISCOUNT } from "@/constants/cookieKey";
import { setCookie } from "cookies-next";
import { useRouter, useSearchParams } from "next/navigation"
import { useEffect } from "react";

const DiscountCodeParamsHandler = () => {
    const router = useRouter();
    const searchParams = useSearchParams();

    useEffect(() => {
        if (searchParams.has(DISCOUNT)) {
            const code = searchParams.get(DISCOUNT)
            if (code) {
                setCookie(DISCOUNT, code)
            }
        }
    }, [searchParams, router]);

    return <></>
}

export default DiscountCodeParamsHandler